import React from "react";
import "../../styles/Tabella.css"

function TabellaOrariPreParto() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "30em"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mer</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">11:00 - 12:00</td>
                    <td className="data-cell">10:45 - 11:45</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaOrariPreParto